import React from 'react';
import { auth } from '../../../auth/firebaseAuth';
import { useAuthMutation } from '../../../hooks/Auth';
import CenterLayout from '../../vendorlink-views/components/CenterLayout';
import ModalLayout from '../components/ModalLayout';
import { Button, Space } from 'antd';
import Text from 'antd/lib/typography/Text';
import ErrorMessage from '../../auth-views/components/ErrorMessage';
import { useAuthState } from 'react-firebase-hooks/auth';

interface VerifyEmailStepProps {
  subtitle?: React.ReactNode;
  onCancel?: () => void;
}

const VerifyEmailStep: React.FC<VerifyEmailStepProps> = ({ subtitle, onCancel }) => {
  const [user] = useAuthState(auth);
  const email = user?.email ?? undefined;
  const { useSendEmailVerification } = useAuthMutation();
  if (!email) {
    return <></>;
  }
  const onSubmit = async () => {
    await useSendEmailVerification.mutateAsync();
  };
  return (
    <CenterLayout>
      <ModalLayout
        header={
          <Space direction="vertical">
            <div className="heading-xs">Verify email</div>
            {subtitle ?? (
              <div className="text-content-secondary">
                We will send a secure link to{' '}
                <Text strong ellipsis>
                  {email}
                </Text>{' '}
                to verify your email.
              </div>
            )}
          </Space>
        }
        content={<ErrorMessage />}
        footer={
          <Space>
            <Button disabled={useSendEmailVerification.isLoading} onClick={() => onSubmit()} type="primary">
              Send verification link
            </Button>
            {onCancel && (
              <Button onClick={onCancel} type="text">
                Cancel
              </Button>
            )}
          </Space>
        }
      />
    </CenterLayout>
  );
};

export default VerifyEmailStep;
